export default __webpack_public_path__ + "85107f878929cf2e43f5fa7582afa9f8.svg";